<template>
  <div id="app">
    <Header />
    <router-view/>
    <ImageModal ref="imageModal" />
  </div>
</template>
<script>
import swalerts from "@/helpers/swalerts";
import Header from "@/components/Header.vue";
import ImageModal from "@/components/ImageModal.vue"; // Import ImageModal
import { mapGetters } from "vuex";
export default {
  mixins: [swalerts],
  computed: {
    ...mapGetters(["getIsMobile"]),
    appVersion: function(){
      return process.env.VUE_APP_VERSION;
    },
  },
  components: {
    Header,
    ImageModal // Add ImageModal to components
  },
  data() {
    return {
      enable_cajamunicipal: process.env.VUE_APP_ENABLE_CAJAMUNICIPAL == 'true'
    };
  },
  methods:{
    onResize(event) {
      console.log('window has been resized', event);
      if (screen.width <= 760) {
        this.$store.commit('setIsMobile', true);
      } else {
        this.$store.commit('setIsMobile', false);
      }
    },
    showImageModal() {
      const imagePath = this.getIsMobile 
        ? 'img/caja_municipal_deshabilitada_short.jpg' // Path to the mobile image
        : 'img/caja_municipal_deshabilitada_big.jpg'; // Path to the default image
      this.$refs.imageModal.openModal(imagePath);
    }
  },
  beforeMount(){
    this.onResize();
  },
  mounted() {
    // Register an event listener when the Vue component is ready
    window.addEventListener('resize', this.onResize);
    if (!this.enable_cajamunicipal) {
      this.showImageModal(); // Conditionally show the modal
    }
  },

  beforeDestroy() {
    // Unregister the event listener before destroying this Vue instance
    window.removeEventListener('resize', this.onResize);
  }
};
</script>
<style>
</style>
